import React, { Fragment } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Grid, FormControl, Radio, RadioGroup, Typography, FormGroup, FormLabel } from "@material-ui/core";
import CustomCheckbox from "../CustomCheckbox";
import translate from '../../other/translate.json';

export default function FilterShow(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru';
  const {isArchive, catalog} = props;
  //console.log(catalog)
  return (
    <React.Fragment>
      <FormControl component="fieldset" className={classes.root}>
        {/* <FormLabel component="legend" className={classes.header}>{translate.Words[`Show${language}`]}:</FormLabel> */}

        <FormGroup>
          { catalog.hasStandart === 1
          ?
          <FormControlLabel key={'FormControlLabel1'}
            control={<CustomCheckbox checked={props.standart === '1'}
              onChange={props.click_standart} />}
            label={translate.Words[`StandardPackage${language}`]}
            className={classes.FClabel}
          />
          :
          null
          }
          {
            props.isRBS === true
              ?
              <FormControlLabel key={'FormControlLabel1'}
                control={<CustomCheckbox checked={props.addStandart === '1'}
                  onChange={props.click_addStandart} />}
                label={translate.Words[`AdditionalStandardPackage${language}`]}
                className={classes.FClabel}
              />
              : null
          }

          {!isArchive?
          <FormControlLabel //onClick={props.click1}
            control={<CustomCheckbox checked={props.promotion === '1'}
              onChange={props.click_promotion} />}
            label={translate.Words[`PromoOffers${language}`]}
            className={classes.FClabel}
          />
          : null}
        </FormGroup>
      </FormControl>
    </React.Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 285,
  },

  header: {
    marginTop: 20,
    marginBottom: 10,
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '28px',
    color: '#24262A'
  },

  FClabel: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  }
}))